import classNames from 'classnames';
import { t } from 'ttag';

import MessageInfoIcon from '@svg/message-info.svg';
import { smartLanding } from '@urls';
import { LocalizedLink } from '@ui/LocalizedLink';
import { Alert } from '@ui/Alert';
import { SmartIcon } from '@components/SmartIcon';

import s from './ProductDetailsSmartBanner.sss';

interface Props {
  className?: string,
  title: string,
}

export const ProductDetailsSmartBanner: React.FC<Props> = ({
  className,
  title,
}) => (
  <LocalizedLink
    className={classNames(s.root, className)}
    theme="clean"
    href={smartLanding}
  >
    <Alert className={s.alert}>
      <SmartIcon
        className={s.icon}
        size="40"
      />
      <div className={s.info}>
        <p className={s.title}>
          {title || t`Оформлюйте підписку SMART`}
        </p>
        <p className={s.description}>
          {t`Отримайте замовлення з безкоштовною доставкою`}
        </p>
      </div>
      <MessageInfoIcon
        className={s.infoIcon}
        width="16"
        height="16"
      />
    </Alert>
  </LocalizedLink>
);
